export const ADD_USER = 'organization/user/CREATE'
export const ADD_USER_SUCCESS = `${ADD_USER}_SUCCESS`

export const UPDATE_SEARCH_EMAIL = 'organization/user/UPDATE_SEARCH_EMAIL'
export const UPDATE_SEARCH_EMAIL_SUCCESS = `${UPDATE_SEARCH_EMAIL}_SUCCESS`

export const UPDATE_SEARCH_EXTERNAL_ID = 'organization/user/UPDATE_SEARCH_EXTERNAL_ID'
export const UPDATE_SEARCH_EXTERNAL_ID_SUCCESS = `${UPDATE_SEARCH_EXTERNAL_ID}_SUCCESS`

export const UPDATE_USER = 'organization/user/UPDATE'
export const UPDATE_USER_SUCCESS = `${UPDATE_USER}_SUCCESS`

export const PASSWORD_RESET = 'organization/user/PASSWORD_RESET'
export const PASSWORD_RESET_SUCCESS = `${PASSWORD_RESET}_SUCCESS`
